import crollVideoEn from '../assets/2C3C7F98-5297-4B80-8DCA-7910EF9C9A22.mp4';
import crollVideoRu from '../assets/kovrification-ru.mp4';
import bestMomentsVideoEn from '../assets/best-moments-eng.mp4';
import bestMomentsVideoRu from '../assets/best-moments-ru.mp4';

// Define supported languages for video selection
export type VideoSupportedLang = 'en' | 'ru';

// Video type definitions
export type VideoType = 'c-roll' | 'best-moments';

// Video mapping structure
interface VideoMap {
  'c-roll': {
    en: string;
    ru: string;
  };
  'best-moments': {
    en: string;
    ru: string;
  };
}

// Central video mapping
const VIDEO_MAP: VideoMap = {
  'c-roll': {
    en: crollVideoEn,
    ru: crollVideoRu,
  },
  'best-moments': {
    en: bestMomentsVideoEn,
    ru: bestMomentsVideoRu,
  },
};

/**
 * Get the appropriate video path based on video type and current language
 * @param videoType - The type of video (c-roll or best-moments)
 * @param currentLanguage - The current app language
 * @returns The video file path
 */
export function getLocalizedVideo(videoType: VideoType, currentLanguage: string): string {
  // Extract base language (e.g., 'en' from 'en-US', 'ru' from 'ru-RU')
  const baseLang = currentLanguage.split('-')[0] as VideoSupportedLang;
  
  // Check if the language is supported for videos, fallback to English
  const lang: VideoSupportedLang = baseLang === 'ru' ? 'ru' : 'en';
  
  return VIDEO_MAP[videoType][lang];
}

/**
 * Get all available video paths for a specific type
 * @param videoType - The type of video
 * @returns Object with all language variants
 */
export function getAllVideoVariants(videoType: VideoType) {
  return VIDEO_MAP[videoType];
}

/**
 * Legacy function to maintain compatibility with existing VIDEO_PATHS usage
 * @param creationTypeName - The creation type name (e.g., 'c-roll', 'podcast-moments')
 * @param currentLanguage - The current app language
 * @returns The video file path or undefined if not found
 */
export function getVideoPath(creationTypeName: string, currentLanguage: string): string | undefined {
  if (creationTypeName === 'c-roll') {
    return getLocalizedVideo('c-roll', currentLanguage);
  }
  if (creationTypeName === 'podcast-moments') {
    return getLocalizedVideo('best-moments', currentLanguage);
  }
  return undefined;
} 